module.exports = __webpack_public_path__ + "static/media/disinvestment.f010c461.png";